import React from 'react';
import { Box } from '@mui/material';
import VeraPromptContextGuide from '../VeraPromptContextGuide';
import { getVeraPromptContextGuide } from '../veraPromptContextGuides';
import { StyledButton } from '../../styles/StyledButtons';
import StyledFieldDescription from '../../styles/StyledFieldDescription';
import { StyledLabel } from '../../styles/styles';
import { MONOSPACE_TEXTAREA_STYLE, PRODUCTION_REFERENCE_SX } from './adminAssistPromptStyles';

interface AdminAssistGroundingPromptTabProps {
  groundingText: string;
  groundingProductionText: string;
  onGroundingChange: (value: string) => void;
  onResetToProduction: () => void;
}

export default function AdminAssistGroundingPromptTab({
  groundingText,
  groundingProductionText,
  onGroundingChange,
  onResetToProduction,
}: AdminAssistGroundingPromptTabProps) {
  return (
    <>
      <VeraPromptContextGuide markdown={getVeraPromptContextGuide('admin_grounding')} />
      <StyledFieldDescription stacked sx={{ mb: 2 }}>
        Rules for when admin assist may use Google Search. Always on for non-advice messages. Use
        portfolio and Maps context first; search only for factual public gaps within Vera guardrails
        (e.g. population, median house prices, council facts).
      </StyledFieldDescription>

      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
          <StyledLabel stacked>Google Search Grounding Prompt</StyledLabel>
          <StyledButton
            size="small"
            variant="outlined"
            onClick={onResetToProduction}
            disabled={groundingText.trim() === groundingProductionText.trim()}
          >
            Reset to coded version
          </StyledButton>
        </Box>
        <textarea
          value={groundingText}
          onChange={(event) => onGroundingChange(event.target.value)}
          rows={14}
          style={{ ...MONOSPACE_TEXTAREA_STYLE, marginTop: 8 }}
        />
      </Box>

      {groundingProductionText && (
        <Box sx={{ mb: 3 }}>
          <StyledLabel stacked>Current coded version (read-only reference)</StyledLabel>
          <Box
            component="pre"
            sx={{ ...PRODUCTION_REFERENCE_SX, maxHeight: 180, overflowY: 'auto' }}
          >
            {groundingProductionText}
          </Box>
        </Box>
      )}
    </>
  );
}
